module.exports = __webpack_public_path__ + "static/media/8x10no1.9481bf97.jpg";